{
 "source": "f3c170e5f79c699a",
 "theme": "8f67b866aea7",
 "cols": 8,
 "gutter": 2,
 "names": [
  "Back",
  "Blank",
  "Chun",
  "Haku",
  "Hatsu",
  "Man1",
  "Man2",
  "Man3",
  "Man4",
  "Man5-Dora",
  "Man5",
  "Man6",
  "Man7",
  "Man8",
  "Man9",
  "Nan",
  "Pei",
  "Pin1",
  "Pin2",
  "Pin3",
  "Pin4",
  "Pin5-Dora",
  "Pin5",
  "Pin6",
  "Pin7",
  "Pin8",
  "Pin9",
  "Shaa",
  "Sou1",
  "Sou2",
  "Sou3",
  "Sou4",
  "Sou5-Dora",
  "Sou5",
  "Sou6",
  "Sou7",
  "Sou8",
  "Sou9",
  "Ton"
 ],
 "sheets": {
  "64": {
   "file": "faces-64.webp",
   "width": 526,
   "height": 443,
   "w": 64,
   "h": 87
  },
  "96": {
   "file": "faces-96.webp",
   "width": 782,
   "height": 663,
   "w": 96,
   "h": 131
  },
  "128": {
   "file": "faces-128.webp",
   "width": 1038,
   "height": 883,
   "w": 128,
   "h": 175
  },
  "192": {
   "file": "faces-192.webp",
   "width": 1550,
   "height": 1318,
   "w": 192,
   "h": 262
  }
 }
}
